/*

    Defer the work (add it to the end of the event queue)

*/

export default function defer(work: () => void) {
  return setTimeout(work, 0)
}
